// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-product-delivery-time',
    // #endregion
    // #region Properties
    props: {
        options: {
            type: Object,
            required: false,
            default: {}
        },
    },
    // #endregion
});
// #endregion
